import styled from "styled-components";
import { darkBlue } from "../../styles/colors";

const HeaderDescription = styled.p`
  color: ${darkBlue};
`;

export default HeaderDescription;
